import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resource } from '@util/resource';
import { DWS } from '@interfaces/dws';

@Injectable({
  providedIn: 'root'
})
export class VisitFrequenciesService {

  constructor() {
  }

  list(page: number = 0, count: number = 999999): Observable<DWS.Page<DWS.VisitFrequency>> {
    return resource('crm://visit-frequencies')
      .params(
        { page, count }
      )
      .get<DWS.Page<DWS.VisitFrequency>>();
  }
}
